import React, {Component} from "react";
import Table1 from "./table1";
import _ from "lodash";
import {paginate} from "../../utils/paginate";
import {getDataAndSchema} from "../../services/toolsService";

class DetailTable1 extends Component {

    onAdd = () => {
        const {value, handleChange, baseInformation} = this.props;

        const newDataList = [...value];
        const {data: newData, schema: newSchema} = getDataAndSchema(baseInformation);

        newDataList.push({
            "dbId": (new Date().getTime()) * -1,
            ...newData
        })
        this.props.handleChange(newDataList);
    };

    onDelete = item => {
        const {value, handleChange} = this.props;

        const newDataList = [...value];
        const index = newDataList.indexOf(item);
        newDataList[index] = {...newDataList[index]};
        newDataList[index].deleted = true;
        this.props.handleChange(newDataList);
    };

    onChange = (dbId, name, itemValue) => {
        // console.log("DetailTable1.onChange(1): ", dbId, name, itemValue);
        const {value, handleChange} = this.props;

        const newDataList = [...value];
        let index = -1;
        if ((typeof dbId) === "string")
            dbId = Number(dbId);
        for (index = 0; index < newDataList.length; index++) {
            if (newDataList[index].dbId === dbId)
                break;
        }
        if (index < newDataList.length) {
            newDataList[index] = {...newDataList[index]};
            newDataList[index][name] = itemValue;
            this.props.handleChange(newDataList);
        }
    }

    getPagedData = () => {
        // console.log("DetailTable.getPagedData(1)");
        const {
            value: dataList,
            baseInformation
        } = this.props;
        const {
            pageSize,
            currentPage,
            sortColumn,
            searchQuery
        } = this.props.sort;

        let filtered = dataList.filter(item => !item.deleted || item.deleted === false);
        if (searchQuery) {
            // filtered = filtered.filter(
            //     item =>
            //         item.title
            //             .toLowerCase()
            //             .indexOf(this.state.searchQuery.toLowerCase()) >= 0
            // );
            filtered = filtered;
        } else {
            filtered = filtered;
        }

        // console.log("DetailTable.getPagedData(2): filtered", filtered);

        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

        const items = paginate(sorted, currentPage, pageSize);

        return {totalCount: filtered.length, dataList: items};
    };

    render = () => {

        const {
            columns,                // TODO
            baseInformation,
            handleSort,
            addButton,
            deleteButton,
            itemList,               // TODO
            itemsMap,               // TODO
            valueProperty,
            textProperty,
            name,
            label,
            error,
            help,
            // handleItemSelect,
            value,
            nullable,
            enterValue,
            ...rest
        } = this.props;
        const {sortColumn} = this.props.sort;

        const {totalCount, dataList} = this.getPagedData();

        const newColumns = [...columns];
        if (deleteButton) {
            newColumns.push(
                {
                    key: "delete",
                    content: item => (
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => this.onDelete(item)}
                        >
                            {deleteButton.text}
                        </button>
                    )
                }
            );
        }

        console.log("newColumns", newColumns)
        console.log("itemsMap", itemsMap)
        console.log("itemList", itemList)
        console.log("baseInformation", baseInformation)

        return (
            <div className="form-group">
                <label htmlFor={name}>{label}</label>
                {addButton && (
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={this.onAdd}
                    >
                        {addButton.text}
                    </button>
                )}
                <div
                    className="checkbox-container"
                >
                    <Table1
                        columns={newColumns}                // TODO
                        baseInformation={baseInformation}
                        data={dataList}
                        sortColumn={sortColumn}
                        handleSort={handleSort}
                        handleChange={this.onChange}
                        itemsMap={itemsMap}                 // TODO
                        itemList={itemList}                 // TODO
                    />
                </div>

                {help && (
                    <small id={`${name}Help`} className="form-text text-muted">
                        {help}
                    </small>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
            </div>
        )
            ;

    }

}

DetailTable1
    .defaultProps = {
    valueProperty: "dbId",
    textProperty: "name",
    nullable: true,
    enterValue: false
};

export default DetailTable1;
